import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listAsWords',
  standalone: true,
})
export class ListAsWordsPipe implements PipeTransform {
  transform(value: string[], joinWith: string = ', ', joinLastWith: string | null = ' and '): string {
    if (value.length === 1) {
      return value[0];
    }

    const joined = value.slice(0, -1).join(joinWith);
    const last = (joinLastWith == null ? joinWith : joinLastWith) + value[value.length - 1];

    return `${joined}${last}`;
  }
}
